import { parse, stringify } from 'hub-http/helpers/params';
import BasePaths from 'automation-ui-routing/BasePaths';
import * as FlowTypes from 'automation-ui-routing/constants/FlowTypes';
export const parseLocation = location => parse(location.search.substring(1));
export const parseHash = location => location.hash.substring(1);
export const joinPathAndQuery = (path, query = {}) => {
  const queryAsStr = stringify(query);
  return queryAsStr ? `${path}?${queryAsStr}` : path;
};
export const getFlowRoute = flowId => `/${BasePaths.PLATFORM}/${BasePaths.FLOW}/${flowId}`;
export const getClassicRoute = flowId => `/${BasePaths.FLOW}/${flowId}`;
export const getFlowRevisionRoute = (flowId, revisionId) => `/${BasePaths.PLATFORM}/${BasePaths.FLOW}/${flowId}/${BasePaths.PLATFORM_FLOW_REVISION}/${revisionId}/${BasePaths.PREVIEW}`;
export const getFlowChangesRoute = flowId => `${getFlowRoute(flowId)}/${BasePaths.CHANGES}`;
export const getEmbeddedFlowRoute = flowId => `/${BasePaths.EMBEDDED_CONFIGS}/${flowId}`;
export const getFlowEditRoute = (flowId, query) => joinPathAndQuery(`${getFlowRoute(flowId)}/${BasePaths.EDIT}`, query);
export const getActionSetEditRoute = (flowId, query) => joinPathAndQuery(`${getFlowRoute(flowId)}/${BasePaths.ACTION_SET}`, query);
export const getFlowDetailsRoute = (flowId, tabId = BasePaths.PERFORMANCE, query = {}) => joinPathAndQuery(`/details/${flowId}/${tabId}`, query);
export const getClassicWorkflowEditRoute = flowId => `${getClassicRoute(flowId)}/${BasePaths.EDIT}`;
export const getFlowEditActionBaseRoute = flowId => `${getFlowRoute(flowId)}/${BasePaths.EDIT}/${BasePaths.PLATFORM_FLOW_CONFIGS}`;
export const getActionSetEditActionBaseRoute = flowId => `${getFlowRoute(flowId)}/${BasePaths.ACTION_SET}/${BasePaths.PLATFORM_FLOW_CONFIGS}`;
export const getFlowReviewRoute = flowId => `${getFlowRoute(flowId)}/${BasePaths.REVIEW}`;
export const getFlowEditRouteContextAware = ({
  flowId,
  isEmbedded,
  revisionId,
  flowType = FlowTypes.WORKFLOW
}) => {
  if (isEmbedded) {
    return getEmbeddedFlowRoute(flowId);
  } else if (revisionId === 0 || revisionId && !isNaN(revisionId)) {
    return `${getFlowRevisionRoute(flowId, revisionId)}/${BasePaths.EDIT}`;
  } else if (flowType === FlowTypes.ACTION_SET) {
    return getActionSetEditRoute(flowId);
  } else {
    return getFlowEditRoute(flowId);
  }
};
export const getEnrollmentDetailsRoute = ({
  flowId,
  enrollmentId,
  objectId
}) => {
  return `${getFlowDetailsRoute(flowId, BasePaths.ENROLLMENTS)}/${BasePaths.ENROLLMENT_DETAILS}/${enrollmentId}/${objectId}`;
};
export const getFlowSettingsRoute = (flowId, tabId) => {
  const baseSettingsRoute = `${getFlowRoute(flowId)}/${BasePaths.SETTINGS}`;
  return tabId ? `${baseSettingsRoute}#${tabId}` : baseSettingsRoute;
};
export const getScheduledTriggersRedesignBaseRoute = flowId => {
  return `/${BasePaths.PLATFORM}/${BasePaths.FLOW}/${flowId}/${BasePaths.EDIT}/${BasePaths.FLOW_CANVAS_ENROLLMENT_CONFIG}/${BasePaths.SCHEDULED}`;
};